import React from 'react';

const Left = ({fill="#111", width="40px"}) => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        class='icon icon-tabler icon-tabler-arrow-left'
        width={width}
        viewBox='0 0 24 24'
        stroke-width='1.5'
        stroke={fill}
        fill='none'
        stroke-linecap='round'
        stroke-linejoin='round'>
        <path stroke='none' d='M0 0h24v24H0z' />
        <line x1='5' y1='12' x2='19' y2='12' />
        <line x1='5' y1='12' x2='11' y2='18' />
        <line x1='5' y1='12' x2='11' y2='6' />
      </svg>
    );
}

export default Left;
